<template>
  <v-list-item
    class="vertical-nav-menu-link"
    v-bind="$attrs"
    active-class="bg-gradient-primary white--text"
    @click="handleClick"
  >
    <v-list-item-icon>
      <!-- Icône avec badge si count > 0 -->
      <v-badge
        v-if="badge > 0"
        :content="badgeDisplay"
        color="error"
        overlap
        bordered
        offset-x="4"
        offset-y="4"
      >
        <font-awesome-icon
          class="mx-auto"
          :class="{ 'alternate-icon-small ml-4': !icon }"
          :icon="['fas', icon || alternateIcon]"
        />
      </v-badge>

      <!-- Icône simple si pas de badge -->
      <font-awesome-icon
        v-else
        class="mx-auto"
        :class="{ 'alternate-icon-small ml-4': !icon }"
        :icon="['fas', icon || alternateIcon]"
      />
    </v-list-item-icon>

    <v-list-item-title>
      {{ title }}
      <!-- Texte du count à côté du label (optionnel, doublon visuel utile sur mobile) -->
      <span v-if="badge > 0" class="notif-label-badge ml-1">
        {{ badgeDisplay }}
      </span>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: 'NavMenuLink',

  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: undefined,
    },
    // Catégorie Vuex à marquer comme lue au clic
    // ex: 'deposit_requests', 'loan_requests', etc.
    // Laisser vide pour les liens sans notification
    notifCategory: {
      type: String,
      default: '',
    },
    // Badge externe (passé par NavMenuGroup ou le drawer)
    // Si non fourni, calculé depuis le store via notifCategory
    badgeOverride: {
      type: Number,
      default: null,
    },
  },

  setup() {
    return {
      alternateIcon: 'circle',
    }
  },

  computed: {
    badge() {
      if (this.badgeOverride !== null) return this.badgeOverride
      if (!this.notifCategory) return 0
      return this.$store.state.notification_counts[this.notifCategory] || 0
    },

    // Affiche "99+" si > 99
    badgeDisplay() {
      return this.badge > 99 ? '99+' : String(this.badge)
    },
  },

  methods: {
    handleClick() {
      if (this.notifCategory && this.badge > 0) {
        this.$store.dispatch('markCategoryRead', this.notifCategory)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.alternate-icon-small {
  font-size: 14px;
  height: 14px;
  width: 14px;
}

.vertical-nav-menu-link {
  &.v-list-item--active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
    @include elevationTransition();
  }
}

// Petit badge texte discret à côté du titre
.notif-label-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #f44336;
  color: #fff;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 5px;
  min-width: 18px;
  line-height: 1.4;
  vertical-align: middle;
}
</style>
